export const DASHBOARD = 'dashboard'
export const STRATEGY_MAP = 'strategy-map'
export const REPORT = 'report'
export const BRIEFING = 'briefing'
export const FILE = 'file'
export const INITIATIVE = 'initiative'
export const SCORECARD_ITEM = 'scorecard-item'
export const WEB_ADDRESS = 'web-address'
export const USER = 'user'
export const GROUP = 'group'
export const BOOKMARK = 'bookmark'
export const ORGANIZATION = 'organization'
export const SLIDE = 'slide'
export const DATASET = 'dataset'
export const DATASET_TREE = 'dataset-tree'
export const ROLLUP_TREE_GROUP = 'rollup-tree-group'
export const EMBEDDABLE_RESOURCE = 'embeddable-resource'
export const IMAGE = 'image'
export const CALENDAR = 'calendar'
export const PROJECT = 'project'
export const VALUE_IMPORT = 'value-import'
export const IMPORT_CONNECTION = 'import-connection'
export const SCHEDULED_EXPORT = 'scheduled-export'
export const SCHEDULED_IMPORT = 'scheduled-import'
export const FORM = 'form'
export const CHART_PLACEHOLDER = 'chart-placeholder'
export const CALENDAR_PERIOD = 'calendar-period'
export const OLD_CHART = 'old-chart'
export const CHART = 'chart'
export const COMMAND = 'command'
export const DATASET_METRIC_SERIES_VALUE = 'dataset-metric-series-value'
export const INITIATIVE_EXPENDITURE = 'initiative-expenditure'
export const INITIATIVE_NOTE = 'initiative-note'
export const INITIATIVE_STATUS = 'initiative-status'
export const METRIC_VALUE = 'metric-value'
export const ORGANIZATION_TREE = 'organization-tree'
export const REPORT_WIDGET = 'report-widget'
export const SCORECARD_NOTE = 'scorecard-note'
export const SCORECARD_WEIGHTS = 'scorecard-weights'
export const SCORING_TYPE = 'scoring-type'
export const DATASET_FIELD = 'dataset-field'
export const USER_PERMISSIONS_AUDIT = 'user-permissions-audit'
export const DATASET_PERMISSIONS_AUDIT = 'dataset-permissions-audit'
export const ORG_PERMISSIONS_AUDIT = 'org-permissions-audit'

export default {
	DASHBOARD,
	STRATEGY_MAP,
	REPORT,
	BRIEFING,
	FILE,
	INITIATIVE,
	SCORECARD_ITEM,
	WEB_ADDRESS,
	USER,
	GROUP,
	BOOKMARK,
	ORGANIZATION,
	SLIDE,
	DATASET,
	DATASET_TREE,
	ROLLUP_TREE_GROUP,
	EMBEDDABLE_RESOURCE,
	IMAGE,
	CALENDAR,
	PROJECT,
	VALUE_IMPORT,
	IMPORT_CONNECTION,
	SCHEDULED_EXPORT,
	SCHEDULED_IMPORT,
	FORM,
	CHART_PLACEHOLDER,
	CALENDAR_PERIOD,
	OLD_CHART,
	CHART,
	COMMAND,
	DATASET_METRIC_SERIES_VALUE,
	INITIATIVE_EXPENDITURE,
	INITIATIVE_NOTE,
	INITIATIVE_STATUS,
	METRIC_VALUE,
	ORGANIZATION_TREE,
	REPORT_WIDGET,
	SCORECARD_NOTE,
	SCORECARD_WEIGHTS,
	SCORING_TYPE,
	DATASET_FIELD,
	USER_PERMISSIONS_AUDIT,
	DATASET_PERMISSIONS_AUDIT,
	ORG_PERMISSIONS_AUDIT
}